<div class="title-bar" mat-dialog-title>
  {{ titolo }}
</div>

<div mat-dialog-content class="dialog-center-cont cont-bordato">
  <app-spinner-overlay></app-spinner-overlay>

  <div style="color: black; font-size: 15px; margin-bottom: 10px">
    Tematica - {{ data.titoloTematica }}
  </div>

  @if (data.titoliEsrs?.length) {
    @for (titoloTema of data.titoliEsrs; track $index) {
      <div class="titolo-elem-padre" [style]="{ '--indentazione': 16 + 10 * $index + 'px' }">
        <span class="etichetta-esrs">{{ titoloTema.etichetta }}</span> {{ titoloTema.titolo }}
      </div>
    }
  }

  <div *ngFor="let elementoChk of iroArray" style="display: flex; align-items: center">
    <!-- CHECKBOX -->
    <mat-checkbox
      [checked]="elementoChk.selected"
      #checkboxElemento
      class="radio-group checkbox-selezione-elementi padding-checkbox"
      [style]="{ '--indentazione': getIndentazioneStyle() }"
      [disabled]="!canEdit || elementoChk.validato"
      (change)="selezionaCheck(elementoChk, $event.checked)"
    >
    </mat-checkbox>

    <div style="display: flex; flex-direction: column">
      <mat-label style="display: flex; align-items: center">
        <!-- TITOLO CHECK BOX -->
        <a
          class="titolo-elemento"
          (click)="
            $event.stopPropagation();
            $event.preventDefault();
            selezionaCheck(elementoChk, !elementoChk.selected)
          "
        >
          {{ data.tipoIro === 'impatto' ? $any(elementoChk).titolo : elementoChk.descrizione }}
        </a>

        <!-- VALIDATO (badge validato) -->
        <!-- <button mat-icon-button *ngIf="elementoChk.validato"
                    class="material-icons-outlined icone-tem icone-label-chack icona-validato "
                    [matTooltip]="'Elemento validato'">
                    <span class=" material-icons-outlined">
                        verified
                    </span>
                </button> -->

        <!-- MODIFICA ELEMENTO -->
        <button
          mat-icon-button
          class="icona-edit-elem"
          [style.align-self]="data.tipoIro === 'impatto' ? '' : 'flex-start'"
          (click)="$event.stopPropagation(); editElemento(elementoChk)"
          *ngIf="this.canEdit && !elementoChk.validato"
        >
          <mat-icon class="icone-label-chack">edit</mat-icon>
        </button>

        @if (elementoChk.selected && !elementoChk.validato && elementoChk.compilazioni?.length) {
          <button
            mat-icon-button
            class="icona-info-elem"
            [style.align-self]="data.tipoIro === 'impatto' ? '' : 'flex-start'"
            (click)="$event.stopPropagation(); mostraValidazioni(elementoChk)"
            *ngIf="this.canEdit && !elementoChk.validato"
          >
            <mat-icon class="icone-label-chack">info</mat-icon>
          </button>
        }

        <!-- INFO VARIABILI IRO -->
        @if (haVariabili(elementoChk)) {
          <span
            class="material-icons-outlined info-variabili-icon"
            [appTooltipOverlay]="tooltipVariabiliTemplate"
            [variabiliTemplate]="{ iro: elementoChk }"
            position="right"
          >
            help_outline
          </span>
        }
      </mat-label>

      <!-- DESCRIZIONE ELEMENTO - solo impatti -->
      @if (data.tipoIro === 'impatto') {
        <div style="display: flex; padding-bottom: 10px">
          <p style="color: var(--grigio); font-size: 13px; margin: 0px">
            {{ elementoChk.descrizione }}
          </p>
        </div>
      }
    </div>
  </div>

  <!-- AGGIUNGI NUOVO ELEMENTO -->
  <button
    mat-stroked-button
    class="aggiungi-nuovo"
    (click)="creaElemento()"
    [disabled]="!this.canEdit"
    [style]="{ '--indentazione': getIndentazioneStyle() }"
  >
    + Aggiungi Nuovo
  </button>
</div>

<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button
      mat-flat-button
      color="accent"
      [disabled]="loading"
      (click)="annulla()"
      class="accent-button"
    >
      Indietro
    </button>
  </div>
  @if (canEdit) {
    <div>
      <button
        mat-flat-button
        color="primary"
        [disabled]="loading"
        (click)="salva()"
        class="primary-button"
        #btnAvanti
      >
        Conferma
      </button>
    </div>
  }
</div>

<ng-template #tooltipVariabiliTemplate let-iro="iro">
  <app-tooltip-variabili-iro
    #cmpTooltipVatiableIro
    [iro]="iro"
    [tipoIro]="data.tipoIro"
  ></app-tooltip-variabili-iro>
</ng-template>
